import linkifyIt from 'linkify-it'
import tlds from 'tlds'
import * as R from 'ramda'

const linkify = linkifyIt()
linkify.tlds(tlds)

// eslint-disable-next-line no-useless-escape
export const websiteRegex =
  /^https?:\/\/[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/

export const termsOfUseUrl = process.env.REACT_APP_TERMS_OF_USE_LINK
export const privacyPolicyUrl = process.env.REACT_APP_PRIVACY_POLICY_LINK
export const cookiePolicyUrl = process.env.REACT_APP_COOKIE_POLICY_LINK

export const isValidLink = (input) => {
  return !R.isEmpty(linkify.match(input || ''))
}

export const websiteProtocalRegx = /^https?:\/\//
export const websiteProtocal = 'http://'

export const isBase64 = R.test(/data:image\/\w*;base64,.*/)

export const openNewTab = (url) => {
  window.open(url, '_blank', 'noopener,noreferrer')
}
